import { render, staticRenderFns } from "./AccountCompanyData.vue?vue&type=template&id=63e3437e"
import script from "./AccountCompanyData.vue?vue&type=script&lang=js"
export * from "./AccountCompanyData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports